export default {
  "home": {
    "connect": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connecter"])},
    "delete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimer"])},
    "disconnect": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Déconnecter"])},
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upsilon File Exchanger for NumWorks"])},
    "rename": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Renommer"])},
    "rename-prompt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez le nouveau nom :"])},
    "download": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Télécharger"])},
    "download-all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tout télécharger"])},
    "records": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fichiers"])},
    "upload": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envoyer"])},
    "size": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Taille"])},
    "bytes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["octets"])}
  },
  "about": {
    "github": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["GitHub"])},
    "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upsilon File Exchanger for NumWorks est une application web qui permet de gérer votre Numworks depuis votre navigateur Web"])},
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["À propos"])}
  },
  "error": {
    "error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur : "])},
    "unknown": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une erreur inconnue est survenue"])},
    "no-usb": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Votre navigateur ne supporte pas le WebUSB, veuillez utiliser un navigateur basé sur Chromium à la place."])}
  }
}